$(document).on("click", ".question_product,.faq_question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question').removeClass('active');
    jQuery('.question_product,.faq_question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});




$(document).on("click", ".custom_button", function (e) {
     var video = jQuery(this).parents('.video_wrapper_custom').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
     jQuery(this).addClass('active');
 }
 });






$(document).on("click", ".custom_checkout_button.disabled", function (e) {
  e.preventDefault();
  document.querySelector('.product_label_lp1').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#compare']", function (e) {
  e.preventDefault();
  document.querySelector('#compare').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#faq']", function (e) {
  e.preventDefault();
  document.querySelector('#faq').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.landing_page_product').scrollIntoView({
    behavior: 'smooth'
  })
});



jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$(window).scroll(function () {
    $('.custom_counter .icons_with_text_flex').each(function () {
      var this_element =  $(this);
      if (this_element.hasClass("start_count")) {
} else {
        if (isScrolledIntoView(this) === true) {
            this_element.addClass('start_count');
$('.start_count .count_js').each(function () {
    $(this).prop('Counter', 0).animate({
            Counter: $(this).data('value')
        }, {
        duration: 2000,
        easing: 'swing',
        step: function (now) {                      
            $(this).text(Math.ceil(now));
        }
    });
});
        }
      }
    });

});



$(document).on("click", ".tab_item_pdp", function (e) {
var data_tab = $(this).attr('data_tab');
$('.tab_item_pdp').removeClass('active');
$(this).addClass('active');
$('.tab_content_pdp').hide();
$('.tab_content_pdp[data_tab="'+data_tab+'"]').show();
});




$(document).on("click", ".ajax_add_cart:not([disabled])", function (e) {
  e.preventDefault();

  var $btn = $(this).addClass('loading_hk');
  var id = $btn.attr('variant_id');
  var quantity = 1;
  var selling_plan = $btn.attr('selling_plan');

  var ajaxData = { quantity: quantity, id: id };
  if (selling_plan) {
    ajaxData.selling_plan = selling_plan;
  }

  $.post('/cart/add.js', ajaxData, function () {
    $.get(window.location.pathname, function (data) {
      var $newDrawer = $(data).find('#cart_drawer_content');
      $('#cart_drawer_content').replaceWith($newDrawer);
      $('#cart-drawer').removeClass('is_empty').addClass('open');
      $btn.removeClass('loading_hk');
    }, 'html');
  }, 'json');
});





$(document).on("click", ".custom_popup_bg,.close_bundle_popup", function (e) {
$('.custom_bunle_popup').hide().removeClass('active');
});

$(document).on("click", ".custom_bunle_item", function (e) {
var data_tab= $(this).attr('data_tab');
$('.custom_bunle_popup').show().addClass('active').attr('target_id',data_tab);
});
$(document).on("click", ".custom_bunle_popup_add:not([disabled])", function (e) {
var parent_popup= $(this).parents('.custom_bunle_popup');
var data_tab= parent_popup.attr('target_id');
var target_bundle = $('.custom_bunle_item[data_tab="'+data_tab+'"]');
var product_main= $(this).parents('.custom_bunle_popup_item');
var variant_id = $(this).attr('variant_id');
var image_url = product_main.find('.custom_bunle_popup_item_image img').attr('src');
var product_title = product_main.find('.custom_bunle_popup_item_title').text();
target_bundle.addClass('active').attr('variant_id',variant_id);
target_bundle.find('.custom_bunle_image img').attr('src',image_url);
target_bundle.find('.custom_bunle_title').text(product_title);
$('.custom_bunle_popup').hide().removeClass('active');
updateGiftBundleActive();
});

function updateGiftBundleActive() {
    var activeCount = $('.custom_bunle_item.active').length,
        giftsToActivate = activeCount > 0 ? activeCount + 1 : 0;

    $('.gifts_bundle_item').removeClass('active').slice(0, giftsToActivate).addClass('active');
    $('.custom_checkout_button').toggleClass('disabled', activeCount !== 3);
    $('.product_label_lp p strong').text(giftsToActivate);
}